module.exports = __webpack_public_path__ + "static/media/sopt19ru.14e994ae.pdf";